import { useNavigate } from 'react-router-dom';

const comparisons = [
  {
    name: 'Kakobuy',
    slug: '/hipobuy-vs-kakobuy',
    accent: 'bg-accent-100 text-accent-700',
    icon: 'ri-scales-line',
  },
  {
    name: 'CSSBuy',
    slug: '/hipobuy-vs-cssbuy',
    accent: 'bg-primary-100 text-primary-700',
    icon: 'ri-scales-3-line',
  },
  {
    name: 'Superbuy',
    slug: '/hipobuy-vs-superbuy',
    accent: 'bg-secondary-200 text-secondary-800',
    icon: 'ri-scales-2-line',
  },
  {
    name: 'Oopbuy',
    slug: '/hipobuy-vs-oopbuy',
    accent: 'bg-accent-100 text-accent-700',
    icon: 'ri-compasses-line',
  },
];

export default function ComparisonSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-xs font-medium text-foreground-500 uppercase tracking-wider mb-6">
            Platform Comparisons
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-800 leading-tight">
            Compare Spreadsheet
            <br />
            Platforms Side by Side
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            See how Hipobuy stacks up against other popular spreadsheet platforms. Honest, detailed comparisons to help you choose the right tool.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {comparisons.map((comp) => (
            <button
              key={comp.name}
              onClick={() => {
                navigate(comp.slug);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-accent-300 transition-all duration-200 cursor-pointer text-left"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg mb-4 ${comp.accent} group-hover:scale-110 transition-transform duration-200`}>
                <i className={`${comp.icon} text-lg`}></i>
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-800 mb-2">
                Hipobuy vs {comp.name}
              </h3>
              <p className="text-xs text-foreground-400 mb-4 leading-relaxed">
                Feature-by-feature comparison covering curation, categories, pricing, and user experience.
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600 group-hover:text-accent-800 transition-colors duration-200 whitespace-nowrap">
                Read comparison
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}